import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { FloatingLabelComponent } from 'design/floatingLabel';
import { TextInputControlComponent } from 'design/textInputControl';
import { TextComponent } from 'design/text/textComponents';
import {
  RateChangeFormValues,
  RateChangeFormViolation,
} from 'types/rateChangeFormTypes';

type Props = {
  values: RateChangeFormValues;
  violations: RateChangeFormViolation[];
  disabled: boolean;
  onNextDateChange(nextValue: null | string): void;
  onNextDateBlur(): void;
};

export const GiroPaymentManagerRateChangeFieldset = (props: Props) => {
  const {
    disabled,
    values,
    violations,
    onNextDateChange,
    onNextDateBlur,
  } = props;

  const {
    giroPaymentManager: ownDictionary,
    inputValidationRequired,
    inputValidationIncorrectValue,
  } = useIntlDictionary();

  const handleNextDateChange = React.useCallback(
    (nextValue: string) => {
      if (nextValue) {
        onNextDateChange(nextValue);
      } else {
        onNextDateChange(null);
      }
    },
    [onNextDateChange]
  );

  const nextDateOnHint = React.useMemo(() => {
    for (let violation of violations) {
      switch (violation.name) {
        case 'NextDateOnMissed':
          return inputValidationRequired;
        case 'NextDateOnIsFuture':
          return inputValidationIncorrectValue;
      }
    }
  }, [inputValidationIncorrectValue, inputValidationRequired, violations]);

  const nextDateOnInvalid = React.useMemo(() => {
    return violations.some(
      (violation) =>
        violation.name === 'NextDateOnMissed' ||
        violation.name === 'NextDateOnIsFuture'
    );
  }, [violations]);

  return (
    <>
      <FloatingLabelComponent
        lifted
        titleText={
          <TextComponent color="secondary" size="m">
            {ownDictionary.rateEditorScreen.dateLabelText}
          </TextComponent>
        }
        hintText={
          <TextComponent color="critical" size="s">
            {nextDateOnHint}
          </TextComponent>
        }
      >
        <TextInputControlComponent
          name="nextDateOn"
          type="date"
          value={values.nextDateOn || ''}
          disabled={disabled}
          invalid={nextDateOnInvalid}
          onValueChange={handleNextDateChange}
          onBlur={onNextDateBlur}
        />
      </FloatingLabelComponent>
      <FloatingLabelComponent
        lifted
        titleText={
          <TextComponent color="secondary" size="m">
            {ownDictionary.rateEditorScreen.rateLabelText(values.m8RateDTO)}
          </TextComponent>
        }
        hintText={null}
        withoutBorder
      >
        <TextInputControlComponent
          name="amount"
          type="text"
          value={ownDictionary.rateEditorScreen.rateValueText(values.m8RateDTO)}
          readOnly
          onValueChange={() => {}}
        />
      </FloatingLabelComponent>
    </>
  );
};
